import { DataTableColumn } from "mantine-datatable";
import { useMemo } from "react";

import { DatabaseMetadataPopover } from "../../../../../components/DatabaseMetadataPopover/DatabaseMetadataPopover.tsx";
import { TableData, TableRow } from "../../../../../components/Table/types.ts";
import { ClikAddress } from "../../../../../types/clikData/clikResult.ts";
import { toLocalDate } from "../../../../../utils/date.ts";
import { getCRCurrentFlagState, getCRDisplayAddress } from "../../utils.ts";

interface Props {
  data: ClikAddress[] | null | undefined;
}

export function useCRAddressesTableData({ data }: Props): TableData {
  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "id",
      hidden: true,
    },
    {
      accessor: "current",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "ClikAddress",
            fieldName: "current",
          }}
        >
          State
        </DatabaseMetadataPopover>
      ),
      sortable: true,
      width: "200px",
    },
    {
      accessor: "address",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "ClikAddress",
            fieldName: "address",
          }}
        >
          Address
        </DatabaseMetadataPopover>
      ),
      sortable: true,
    },
    {
      accessor: "lastUpdatedDate",
      title: (
        <DatabaseMetadataPopover
          databaseMetadata={{
            tableName: "ClikAddress",
            fieldName: "lastUpdatedDate",
          }}
        >
          Last Update Date
        </DatabaseMetadataPopover>
      ),
      sortable: true,
      width: "230px",
    },
  ];

  const rows = useMemo(() => {
    return data?.map((item) => {
      return {
        id: item.id,
        current: getCRCurrentFlagState(item.current),
        address: getCRDisplayAddress(item),
        lastUpdatedDate:
          item.lastUpdatedDate && toLocalDate(item.lastUpdatedDate),
      };
    });
  }, [data]);

  return [columns, rows];
}
